import { Observable } from "rxjs";
import { get } from "../../../service/api";
import { ITokenPair } from "../../auth/interface/dto/token-pair";
import { IFooterDto } from "../interface/dto/footer.dto";

export const getGlobals = (tokens: ITokenPair): Observable<IFooterDto> =>
    get<IFooterDto>("/content/footer", undefined, tokens);
